import React, { useState, useEffect } from "react";
import { Card, Input, Flex, Table, Tag, Image, Button, Drawer, Modal, Dropdown, message } from 'antd'
import { CaretDownOutlined, EyeOutlined, GlobalOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom'
import { getCarInfo, getHire, getProtection, getMaintenance, getInsurance } from '../../API/archives'
import { useTranslation, Trans } from 'react-i18next';
import locale from 'antd/locale/zh_CN';
import "./archives.scss"
const { Search } = Input;

const Archives = ({ setLng }) => {

    const navigate = useNavigate()

    const [open, setOpen] = useState(false);

    const [show, setShow] = useState(false)

    const { t, i18n } = useTranslation();

    const [previewImage, setPreviewImage] = useState('');

    const [info, setInfo] = useState('');

    const [hireData, setHireData] = useState([]);

    const [maintenanceData, setMaintenanceData] = useState([]);

    const [accidentData, setAccidentData] = useState([]);

    const [insuranceData, setInsuranceDataData] = useState([]);

    const [buyContracts, setBuyContracts] = useState([]);

    const [insuranceContracts, setInsuranceContracts] = useState([]);

    const [isModalVisible, setIsModalVisible] = useState(false);

    const [searchData, setSearchData] = useState("")

    const [hirePage, setHirePage] = useState({
        page: 1,
        pageSize: 10,
        total: 0
    });

    const [maintenancePage, setMaintenancePage] = useState({
        page: 1,
        pageSize: 10,
        total: 0
    });

    const [accidentPage, setAccidentPage] = useState({
        page: 1,
        pageSize: 10,
        total: 0
    });

    const [insurancePage, setInsurancePage] = useState({
        page: 1,
        pageSize: 10,
        total: 0
    });

    const [flag, setFlag] = useState(false)
    // 添加屏幕宽度状态
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    // 监听窗口大小变化
    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 768);
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const onSearch = (value, _e, info) => {
        console.log(info, _e, value);
        setSearchData(() => value)
        getCarData(value)
        setShow(true)
    }

    // 根据屏幕大小动态设置rentalColumns
    const getRentalColumns = () => {
        const baseColumns = [
            {
                title: t('rentReturn.id'),
                dataIndex: 'id',
                key: 'id',
                width: "7%",
                align: "center",
                fixed: isSmallScreen ? false : 'left',
            },
            {
                title: t('rentReturn.people'),
                key: 'hirer',
                align: "center",
                dataIndex: 'hirer',
                fixed: isSmallScreen ? false : 'left',
            },
            {
                title: t('rentReturn.telephony'),
                key: 'phonenumber',
                align: "center",
                dataIndex: 'phonenumber',
            },
            {
                title: t('rentReturn.picture'),
                dataIndex: 'photo',
                key: 'photo',
                align: "center",
                render: (record, { tags }) => (
                    <div style={{ color: "#FD5104", cursor: "pointer" }} onClick={() => {
                        setPreviewImage(process.env.NODE_ENV === "development" ? `http://58.221.151.226:8299${record}` : `http://183.249.69.67:8000${record}`); // 假设 picture 字段是图片URL
                        // setPreviewImage(process.env.NODE_ENV === "development" ? `https://carhire.ecarro.cn${record}` : `http://183.249.69.67:8000${record}`); // 假设 picture 字段是图片URL
                        setIsModalVisible(true);
                    }}>
                        <EyeOutlined /> {t('rentReturn.view')}
                    </div>
                ),
            },
            {
                title: t('rightInfo.number'),
                key: 'operatorId',
                align: "center",
                dataIndex: 'operatorId',
            },
            {
                title: t('rentReturn.date'),
                key: 'hireDateStart',
                align: "center",
                dataIndex: 'hireDateStart',
            },
            {
                title: t('rentReturn.deadline'),
                key: 'hireDateEnd',
                align: "center",
                dataIndex: 'hireDateEnd',
            },
            {
                title: t('rentReturn.category'),
                key: 'hireMode',
                dataIndex: 'hireMode',
                align: "center",
                render: (_, { tags }) => (
                    <Tag color={`${_ == "短租" ? "green" : "blue"}`}>
                        {_}
                    </Tag>
                ),
            },
            {
                title: t('rentReturn.status'),
                key: 'checkStatus',
                dataIndex: 'checkStatus',
                align: "center",
                render: (_, { tags }) => (
                    <Tag color={`${_ == "租车点检完成" ? "green" : _ == "还车点检失败" ? "red" : _ == "待还车点检" ? "orange" : _ == "租车点检中" ? "blue" : "#ccc"}`}>
                        {_}
                    </Tag>
                ),
            },
            {
                title: t('rentReturn.inspect'),
                dataIndex: 'checkingInformation',
                key: 'checkingInformation',
                align: "center",
                render: (record, { tags }) => (
                    <div style={{ color: "#FD5104", cursor: "pointer" }} onClick={() => {
                        setPreviewImage(process.env.NODE_ENV === "development" ? `http://58.221.151.226:8299${record}`: `http://183.249.69.67:8000${record}`); // 假设 picture 字段是图片URL
                        // setPreviewImage(process.env.NODE_ENV === "development" ? `https://carhire.ecarro.cn${record}` : `http://183.249.69.67:8000${record}`); // 假设 picture 字段是图片URL
                        setIsModalVisible(true);
                    }}>
                        <EyeOutlined /> {t('rentReturn.view')}
                    </div>
                ),
            },
            {
                title: t('rentReturn.order'),
                key: 'orderNumber',
                align: "center",
                dataIndex: 'orderNumber',
            },
            {
                title: t('rentReturn.location'),
                key: 'returnLocation',
                align: "center",
                dataIndex: 'returnLocation',
            },
            {
                title: t('rentReturn.contract'),
                key: 'hireContract',
                align: "center",
                dataIndex: 'hireContract',
                align: "center",
                render: (record, { tags }) => (
                    <div style={{ color: "#FD5104", cursor: "pointer" }} onClick={() => {
                        setPreviewImage(process.env.NODE_ENV === "development" ? `http://58.221.151.226:8299${record}`: `http://183.249.69.67:8000${record}`); // 假设 picture 字段是图片URL
                        // setPreviewImage(process.env.NODE_ENV === "development" ? `https://carhire.ecarro.cn${record}` : `http://183.249.69.67:8000${record}`); // 假设 picture 字段是图片URL
                        setIsModalVisible(true);
                    }}>
                        <EyeOutlined /> {t('rentReturn.view')}
                    </div>
                ),
            },
            {
                title: t('rentReturn.cost'),
                key: 'costDetails',
                valueType: 'digit', // 使用 'digit' 类型会自动限制为数字
                align: "center",
                dataIndex: 'costDetails',
            },
        ];
        
        return baseColumns;
    };

    const maintenanceColumns = [
        {
            title: t('rentReturn.id'),
            dataIndex: 'id',
            key: "id",
            align: "center",
        },
        {
            title: t('maintain.date'),
            key: 'maintenanceDate',
            align: "center",
            dataIndex: 'maintenanceDate',
        },
        {
            title: t('maintain.category'),
            key: 'maintainCategory',
            dataIndex: 'maintainCategory',
            valueType: 'select',
            align: "center",
            render: (_, { tags }) => (
                <Tag color={`${_ == "维护" ? "green" : "blue"}`}>
                    {_}
                </Tag>
            ),
        },
        {
            title: t('maintain.section'),
            key: 'maintenanceContent',
            align: "center",
            dataIndex: 'maintenanceContent',
        },
        {
            title: t('rentReturn.cost'),
            key: 'costDetails',
            align: "center",
            dataIndex: 'costDetails',
        },
    ];

    const accidentColumns = [
        {
            title: t('rentReturn.id'),
            dataIndex: 'id',
            key: "id",
            align: "center",
        },
        {
            title: t('incident.date'),
            key: 'accidentDate',
            align: "center",
            dataIndex: 'accidentDate',
        },
        {
            title: t('incident.category'),
            key: 'accidentCategory',
            dataIndex: 'accidentCategory',
            align: "center",
            tooltip: '类别包含：事故处理/维权',
            render: (_, { tags }) => (
                <Tag color={`${_ == "事故处理" ? "green" : "blue"}`}>
                    {_}
                </Tag>
            ),
        },
        {
            title: t('rentReturn.cost'),
            key: 'costDetails',
            align: "center",
            dataIndex: 'costDetails',
        },
        {
            title: t('incident.accident'),
            key: 'accidentInformation',
            align: "center",
            dataIndex: 'accidentInformation',
        },
    ];


    const insuranceColumns = [
        {
            title: t('rentReturn.id'),
            dataIndex: 'id',
            align: "center",
            key: "id",
        },
        {
            title: t('insurance.date'),
            key: 'insurancePurchaseDate',
            align: "center",
            dataIndex: 'insurancePurchaseDate',
        },
        {
            title: t('insurance.category'),
            key: 'insuranceCategory',
            dataIndex: 'insuranceCategory',
            align: "center",
            tooltip: '类别包含：购买保险/续费保险',
            render: (_, { tags }) => (
                <Tag color={`${_ == "购买保险" ? "green" : "blue"}`}>
                    {_}
                </Tag>
            ),
        },
        {
            title: t('rentReturn.cost'),
            key: 'costDetails',
            align: "center",
            dataIndex: 'costDetails',
        },
    ];

    const logOut = () => {
        localStorage.removeItem('img');
        localStorage.removeItem('menuKey');
        localStorage.removeItem('token');
        sessionStorage.clear()
        navigate('login')
    }

    const items = [
        {
            label: <a onClick={() => navigate('/forgot')}>{t('user.reset')}</a>,
            key: '0',
        },
        {
            label: <a onClick={logOut}>{t('user.logOut')}</a>,
            key: '1',
        },
    ];

    const languageItem = [
        {
            label: <a onClick={() => {
                localStorage.setItem("language", "en")
                setLng("en")
                changeLanguage("en")
            }}>{t('english')}</a >,
            key: '0',
        },
        {
            type: 'divider',
        },
        {
            label: <a onClick={() => {
                localStorage.setItem("language", "zh")
                setLng("zn")
                changeLanguage("zh")
            }}>{t('chinese')}</a >,
            key: '1',
        },
    ]

    const getCarData = (value) => {
        if (value) {
            getCarInfo(value).then(res => {
                if (res?.data?.code === 200) {
                    console.log(res);

                    setInfo(res.data.data)
                    setBuyContracts(res.data.data.contracts?.filter(item => item.contractType == 0))
                    setInsuranceContracts(res.data.data.contracts?.filter(item => item.contractType == 1))
                } else {
                    message.error(res?.data?.msg)
                }
            })
            getHire({ pageNum: hirePage?.page, pageSize: hirePage?.pageSize, carNumber: value }).then(res => {
                if (res?.data?.code === 200) {
                    let arr = res.data.rows?.map((item, index) => ({
                        ...item,
                        key: item.id,
                        id: (hirePage?.page - 1) * 10 + index + 1,
                        hireMode: item.hireMode == "0" ? "短租" : "融资租赁",
                        checkStatus: item.checkStatus == "0" ? "租车点检完成" : item.checkStatus == "1" ? "还车点检失败" : item.checkStatus == "2" ? "待还车点检" : item.checkStatus == "3" ? "租车点检中" : "未开始点检"
                    }))
                    setHirePage({
                        page: hirePage?.page,
                        pageSize: hirePage?.pageSize,
                        total: res.data.total
                    })
                    setHireData(arr)
                } else if (res?.data?.code == 401) {
                    navigate('/login')
                } else {
                    message.error(res?.data?.msg)
                }
            })
            getMaintenance({ pageNum: maintenancePage?.page, pageSize: maintenancePage?.pageSize, carNumber: value }).then(res => {
                if (res?.data?.code === 200) {
                    let arr = res.data.rows?.map((item, index) => ({
                        ...item,
                        key: item.id,
                        id: (maintenancePage?.page - 1) * 10 + index + 1,
                        maintainCategory: item.maintainCategory == "0" ? "维护" : "保养",
                    }))
                    setMaintenancePage({
                        page: maintenancePage?.page,
                        pageSize: maintenancePage?.pageSize,
                        total: res.data.total
                    })
                    setMaintenanceData(arr)
                } else if (res?.data?.code == 401) {
                    navigate('/login')
                } else {
                    message.error(res?.data?.msg)
                }
            })
            getProtection({ pageNum: accidentPage?.page, pageSize: accidentPage?.pageSize, carNumber: value }).then(res => {
                if (res?.data?.code === 200) {
                    let arr = res.data.rows?.map((item, index) => ({
                        ...item,
                        key: item.id,
                        id: (accidentPage?.page - 1) * 10 + index + 1,
                        accidentCategory: item.accidentCategory == "0" ? "事故处理" : "维权",
                    }))
                    setAccidentPage({
                        page: accidentPage?.page,
                        pageSize: accidentPage?.pageSize,
                        total: res.data.total
                    })
                    setAccidentData(arr)
                } else if (res?.data?.code == 401) {
                    navigate('/login')
                } else {
                    message.error(res?.data?.msg)
                }
            })
            getInsurance({ pageNum: insurancePage?.page, pageSize: insurancePage?.pageSize, carNumber: value }).then(res => {
                if (res?.data?.code === 200) {
                    console.log(res);
                    let arr = res.data.rows?.map((item, index) => ({
                        ...item,
                        key: item.id,
                        id: (insurancePage?.page - 1) * 10 + index + 1,
                        insuranceCategory: item.insuranceCategory == "0" ? "购买保险" : "续费保险",
                    }))
                    setInsurancePage({
                        page: insurancePage?.page,
                        pageSize: insurancePage?.pageSize,
                        total: res.data.total
                    })
                    setInsuranceDataData(arr)
                } else if (res?.data?.code == 401) {
                    navigate('/login')
                } else {
                    message.error(res?.data?.msg)
                }
            })
        }
    }

    const moduleCancel = () => {
        setIsModalVisible(false)
        setPreviewImage(() => "")
    }

    useEffect(() => {
        if (flag) {
            setFlag(true)
        } else {
            getCarData(searchData)
        }
    }, [hirePage?.page, maintenancePage?.page, accidentPage?.page, insurancePage?.page])

    const HireChange = (page) => {
        setHirePage({
            page: page,
            pageSize: hirePage.pageSize,
            total: hirePage.total
        })
    }

    const maintenanceChange = (page) => {
        setMaintenancePage({
            page: page,
            pageSize: maintenancePage.pageSize,
            total: maintenancePage.total
        })
    }

    const accidentChange = (page) => {
        setAccidentPage({
            page: page,
            pageSize: maintenancePage.pageSize,
            total: maintenancePage.total
        })
    }

    const insuranceChange = (page) => {
        setInsurancePage({
            page: page,
            pageSize: insurancePage.pageSize,
            total: insurancePage.total
        })
    }

    return (
        <div className="archives">
            <div className="crchivesTop">
                <Search className="search" placeholder={t('input.placeholder')} onSearch={onSearch} enterButton />
                <div className="tool">
                    <div className="switch">
                        {t('language')} <Dropdown
                            menu={{
                                items: languageItem,
                            }}
                            trigger={['click']}
                        >
                            <GlobalOutlined className="more" onClick={(e) => e.preventDefault()} />
                        </Dropdown>
                    </div>
                    <Card className='userInfo'>
                        <img className='use' src={`https://img2.baidu.com/it/u=844991488,1562672971&fm=253&fmt=auto&app=120&f=JPEG`} alt="头像" />
                        {t('user.name')}
                        <Dropdown
                            menu={{
                                items,
                            }}
                            trigger={['click']}
                        >
                            <CaretDownOutlined className="more" onClick={(e) => e.preventDefault()} />
                        </Dropdown>
                    </Card>
                </div>
            </div>
            {show ?
                <React.Fragment>
                    <div className="box">
                        <Card className='carInfo'>
                            <Flex gap="middle" vertical>
                                <Flex align="center" gap="middle">
                                    <div className="title"><span className="piece"></span>{t('carInfo.title')}</div>
                                </Flex>
                            </Flex>
                            <div className="main">
                                <div className="picture">
                                    <img src={info?.carRegistration?.carPictures ? process.env.NODE_ENV === "development" ? `http://58.221.151.226:8299${info?.carRegistration?.carPictures}` : `http://183.249.69.67:8000${info?.carRegistration?.carPictures}` : ""} alt="" />
                                    {/* <img src={info?.carRegistration?.carPictures ? process.env.NODE_ENV === "development" ? `https://carhire.ecarro.cn${info?.carRegistration?.carPictures}` : `http://183.249.69.67:8000${info?.carRegistration?.carPictures}` : ""} alt="" /> */}
                                </div>
                                <div className="right">
                                    <div className="info">
                                        <div className="strip">
                                            <div className="key">{t('carInfo.car_id')}：</div>
                                            <div className="value">{info?.carRegistration?.carNumber || "-"}</div>
                                        </div>
                                        <div className="strip">
                                            <div className="key">{t('varehicleInformation.model')}：</div>
                                            <div className="value">{info?.carRegistration?.carModel || "-"}</div>
                                        </div>
                                        <div className="strip">
                                            <div className="key">{t('varehicleInformation.motor')}：</div>
                                            <div className="value">{info?.carRegistration?.motorType || "-"}</div>
                                        </div>
                                        <div className="strip">
                                            <div className="key">{t('varehicleInformation.battery_Type')}：</div>
                                            <div className="value">{info?.carRegistration?.batteryType || "-"}</div>
                                        </div>
                                        <div className="strip">
                                            <div className="key">{t('varehicleInformation.insurance')}：</div>
                                            <div className="value">{`${info?.carRegistration?.insuranceDateStart || "-"} - ${info?.carRegistration?.insuranceDateEnd || "-"}`}</div>
                                        </div>
                                        <div className="strip">
                                            <div className="key">{t('varehicleInformation.maintenance')}：</div>
                                            <div className="value">{info?.carRegistration?.maintenanceCountdown || "-"} 天</div>
                                        </div>
                                    </div>
                                    <div className="contract">
                                        <div className="agreement">
                                            <div className="text">{t('varehicleInformation.lease')}：</div>
                                            <div className="imgs">
                                                {buyContracts?.map((item, index) => (
                                                    <img key={index} src={process.env.NODE_ENV === "development" ? `http://58.221.151.226:8299${item.contractAddress}` : `http://183.249.69.67:8000${item.contractAddress}`} alt="" />
                                                    // <img key={index} src={process.env.NODE_ENV === "development" ? `https://carhire.ecarro.cn${item.contractAddress}` : `http://183.249.69.67:8000${item.contractAddress}`} alt="" />
                                                ))}
                                            </div>
                                        </div>
                                        <div className="agreement">
                                            <div className="text">{t('varehicleInformation.insure')}：</div>
                                            <div className="imgs">
                                                {insuranceContracts?.map((item, index) => (
                                                    <img key={index} src={process.env.NODE_ENV === "development" ? `http://58.221.151.226:8299${item.contractAddress}` : `http://183.249.69.67:8000${item.contractAddress}`} alt="" />
                                                    // <img key={index} src={process.env.NODE_ENV === "development" ? `https://carhire.ecarro.cn${item.contractAddress}` : `http://183.249.69.67:8000${item.contractAddress}`} alt="" />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>
                    <div className="bigbox">
                        <Card className='carInfo'>
                            <Flex gap="middle" vertical>
                                <Flex align="center" gap="middle">
                                    <div className="title"><span className="piece"></span>{t('rentReturn.title')}</div>
                                </Flex>
                            </Flex>
                            <div className="main">
                                <Table scroll={{ x: 2000, }} pagination={{ total: hirePage.total, current: hirePage.page || 1, pageSize: hirePage.pageSize || 10, onChange: HireChange }} bordered={true} columns={getRentalColumns()} dataSource={hireData} />
                            </div>
                        </Card>
                    </div>
                    <Modal
                        title={t('viewImage')}
                        open={isModalVisible}
                        footer={false}
                        onCancel={moduleCancel}
                    >
                        <Image
                            alt="预览"
                            style={{ width: '100%' }}
                            fallback="data:image/png;base64,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"
                            src={previewImage}
                        />
                    </Modal>
                    <div className="bigbox">
                        <Card className='carInfo'>
                            <div className="main">
                                <div className="tables">
                                    <Flex gap="middle" vertical>
                                        <Flex align="center" gap="middle">
                                            <div className="title"><span className="piece"></span>{t('maintain.title')}</div>
                                        </Flex>
                                    </Flex>
                                    <Table scroll={{ x: 1000 }} bordered={true} pagination={{ total: maintenancePage.total, current: maintenancePage.page || 1, pageSize: maintenancePage.pageSize || 10, onChange: maintenanceChange }} columns={maintenanceColumns} dataSource={maintenanceData} />
                                </div>
                                <div className="tables">
                                    <Flex gap="middle" vertical>
                                        <Flex align="center" gap="middle">
                                            <div className="title"><span className="piece"></span>{t('incident.title')}</div>
                                            <Button type="primary" className="btn1" onClick={() => setOpen(true)}>
                                                {t('insurance.title')}
                                            </Button>
                                        </Flex>
                                    </Flex>
                                    <Table scroll={{ x: 1000 }} bordered={true} pagination={{ total: accidentPage.total, current: accidentPage.page || 1, pageSize: accidentPage.pageSize || 10, onChange: accidentChange }} columns={accidentColumns} dataSource={accidentData} />
                                </div>
                            </div>
                        </Card>
                        <Drawer
                            closable
                            destroyOnClose
                            title={<p>{t('back')}</p>}
                            className="drawer"
                            placement="right"
                            open={open}
                            maskClosable={false}
                            onClose={() => setOpen(false)}
                        >
                            <div className="title"><span className="piece"></span>{t('insurance.title')}</div>
                            <Table bordered={true} pagination={{ total: insurancePage.total, current: insurancePage.page || 1, pageSize: insurancePage.pageSize || 10, onChange: insuranceChange }} columns={insuranceColumns} dataSource={insuranceData} />
                        </Drawer>
                    </div>
                    <footer>©2025昌谷（宁波）  备案号：<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备2023036666号-1</a></footer>
                </React.Fragment> : <></>}
        </div>
    )
}

export { Archives }
